import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
/* import Tilt from 'react-tilt'; */
import { useTranslation } from 'react-i18next';
import 'react-modal-video/scss/modal-video.scss';
import LazyLoad from 'react-lazyload';
import Bubble from '../components/bubbleComp'
import ReactGA from 'react-ga';

const HomeContent = () => {

    const [isOpen, setIsOpen] = useState(false)

    const showLogo = false
    const showAppStore = false
    const showPlayStore = false

    const openModal = () => {
        setIsOpen(true)

        ReactGA.event({
            category: 'Media',
            label: 'main-video',
            action: 'Opened video',
            value: 1
        });
    }

    const onModalClose = () => {
        setIsOpen(false)
    }

    const { t } = useTranslation();

    const noPntEvents = {
        pointerEvents: 'none'
    }

    const pntEvents = {
        pointerEvents: 'auto'
    }

    return (

        <section id="home" className="home home-one">
            <div className="home-decor">
                <div className="home-circle1 circle-shadow ">
                    <Bubble aling="right" elem={<LazyLoad><img src="assets/images/ourmind-logo-head.png" alt="" /></LazyLoad>} text={`${t('hi')}!`} />
                </div>
            </div>
            <div className="container" style={noPntEvents}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="home-contain">
                            <div>
                                {showLogo ? <img src="assets/images/ourmind_logo.png" alt="caption-img" className="caption-img" /> : ''}
                                <h4 className="home-content-slogan1">{t('the future of knowledge')}</h4>
                                <h1><span className="f-bold">ourmind</span>
                                </h1>
                                <p style={{ maxWidth: '400px' }} className="home-content-slogan">{t('share your mind and thrive')}</p>
                                {showAppStore ? <a href={null} style={pntEvents}><img src="assets/images/appstore.png" alt="appstore" className="store" /></a> : ''}
                                {showPlayStore ? <a href={null} style={pntEvents}><img className="ml-10 store" src="assets/images/play-store.png" alt="play-store" /></a> : ''}

                                <div className="play-button" style={{ ...pntEvents }}>
                                    <ModalVideo channel='youtube' autoPlay={1} isOpen={isOpen} showinfo={0} videoId={t('headVideoYoutubeId')} height={600} width={800} onClose={() => onModalClose()} />
                                    <a className="popup-vimeo animated-circle one" >
                                        <img src="assets/images/home2/play-button.png" alt="play-button" onClick={openModal} className="img-fluid" />
                                    </a>
                                    <span>{t('play video')}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )

}

export default HomeContent


// WEBPACK FOOTER //
// ./src/components/homeContent.js